import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Skeleton from '../UI/Skeleton'
import { File, FileDoc, FilePdf, FileXls, FileJpg, FilePng } from 'phosphor-react'
import { Col } from 'reactstrap'


class FileComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fileType: '',
            // eslint-disable-next-line no-undef
            fileUrl: process.env.REACT_APP_FILEURL,
        }
    }

    componentWillMount() {
        if (this.props.file) {
            const splittedFilelink = this.props.file.split('.')
            let fileType = ''
            if (splittedFilelink.length > 1) fileType = splittedFilelink[splittedFilelink.length - 1]
            switch (fileType) {
                case 'xlsx':
                    this.setState({ fileType: 'xls' })
                    break
                case 'xls':
                    this.setState({ fileType: 'xls' })
                    break
                case 'docx':
                    this.setState({ fileType: 'doc' })
                    break
                case 'doc':
                    this.setState({ fileType: 'doc' })
                    break
                case 'pdf':
                    this.setState({ fileType: 'pdf' })
                    break
                case 'jpeg':
                    this.setState({ fileType: 'jpg' })
                    break
                case 'jpg':
                    this.setState({ fileType: 'jpg' })
                    break
                case 'png':
                    this.setState({ fileType: 'png' })
                    break
                default:
                    this.setState({ fileType: '' })
                    break
            }

        }
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <Col xl={3} lg={4} md={6} sm={12} className="study file-wrapper">
                            <Skeleton width={40} height={40} className="d-block mb-2 mx-auto" />
                            <Skeleton width={100} className="md-font-size d-block mx-auto" />
                        </Col>
                        :
                        <Col xl={3} lg={4} md={6} sm={12} className='study file-wrapper' onClick={() => window.open(`${this.state.fileUrl}/${this.props.file}`, '_blank')}>
                            {this.state.fileType === 'pdf' && <FilePdf className='file-icon' size={40} weight="fill" />}
                            {this.state.fileType === 'xls' && <FileXls className='file-icon' size={40} weight="fill" />}
                            {this.state.fileType === 'doc' && <FileDoc className='file-icon' size={40} weight="fill" />}
                            {this.state.fileType === 'jpg' && <FileJpg className='file-icon' size={40} weight="fill" />}
                            {this.state.fileType === 'png' && <FilePng className='file-icon' size={40} weight="fill" />}
                            {!this.state.fileType && <File className='file-icon' size={40} weight="fill" />}
                            <div className='md-font-size'>{this.props.title}</div>
                        </Col>
                }
            </React.Fragment>
        )
    }
}

FileComponent.propTypes = {
    t: PropTypes.func,
    history: PropTypes.object,
    file: PropTypes.string,
    title: PropTypes.string,
    skeleton: PropTypes.bool,
}


export default withTranslation()(FileComponent)


// WEBPACK FOOTER //
// ./src/components/Study/File.jsx